import { render, staticRenderFns } from "./TemplateServico.vue?vue&type=template&id=0ce582b0"
import script from "./TemplateServico.vue?vue&type=script&lang=js"
export * from "./TemplateServico.vue?vue&type=script&lang=js"
import style0 from "./TemplateServico.vue?vue&type=style&index=0&id=0ce582b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports